import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.DARK_GREEN,
    detailIdProp: 'psId',
    detailUrl: '/DepPsDetail',
    listUrl: '/DepPsList',
    mapProp: 'map',
    name: '物理机',
    textProp: 'psName',
    type: 'PHYS',
}
